<template>
  <transition name="slide-fade" >

    <div  id="academicsHolder" style="min-height: 90vh !important;">
      <div class="uk-child-width-1-1" uk-grid>
        <div class=" uk-background-secondary uk-light" style="padding: 20px; color: rgb(197,179,88) !important;">
          <div class="uk-container uk-container-small ">
            <p class="uk-text-center uk-text-lead@l uk-text-large@l">
              Choose from our 60+ Undergraduate degrees programmes the path in which you wish to grow with us.
            </p>
          </div>
        </div>
        <div>
          <div class="uk-container uk-container-large uk-margin-small">
            <div >
              <div class="uk-child-width-1-2@m" uk-grid>

            <!-- large search box -->
                <div>
                  <form class="uk-search uk-search-large uk-visible@l">
                    <span uk-search-icon></span>
                    <input class="uk-search-input " type="search" placeholder="Search..." v-model="searchDegree" style="width: 100%">
                  </form>
                </div>
                <!-- small search box -->
                <div class=" uk-hidden@l ">
                  <form class="uk-search uk-search-default">
                    <span uk-search-icon></span>
                    <input class="uk-search-input " type="search" placeholder="Search..." v-model="searchDegree" style="width: 100%">

                  </form>
                </div>




                <div>
                  <div>
                    <div class="  uk-margin-top" uk-grid>

                      <div>
                        <button class="uk-button uk-button-default uk-align-right "
                                v-bind:class="{ 'uk-button-secondary': tableView }"
                                @click="switchToTable" >Table</button>
                        <button class="uk-button uk-button-default  uk-align-right"
                                v-bind:class="{ 'uk-button-secondary': gridView }"
                                @click="switchToGrid"
                        >Grid</button>
                      </div>

                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
        <div class="uk-background-muted  uk-margin-remove-top uk-padding ">
          <div class="uk-container uk-container-large" v-if="gridView === true">

            <div class="uk-child-width-1-1 uk-child-width-1-1@m uk-child-width-1-1@l " uk-grid >
              <div v-for="item in filterDegree" style="margin-top: 10px">
                <div class="uk-card uk-card-default" style="border-radius: 15px;">
                  <div class="uk-card-media-top">
                    <!--<img :src="'http://cmsapi.ncu.edu.jm/' + item.thumbnailImage" class="uk-responsive-height uk-responsive-width" alt=""
                         style="max-width: 300px; max-height: 300px; height: auto; width: auto; border-top-left-radius: 15px; border-top-right-radius: 15px; ">-->
                  </div>
                  <div class="uk-card-body uk-padding-small" >
                   <!-- <h4 class="specHeading" style="color: rgb(197,179,88) !important;">{{ item.degreeName }}</h4>-->
                    <div>
                      <div class="">
                        <div :id="item.id" @click="findNewDegree(item.acf.program_slug)" style="cursor: pointer" class="uk-flex uk-flex-between ">
                          <div>
                            <div>
                              <h3 class=" uk-text-capitalize uk-text-bold" style=" font-weight: bold">{{ item.acf.program_name }}</h3>
                            </div>
                            <div style="margin-top: -15px">
                              <span class="uk-badge uk-text-small" style="padding: 5px 10px; background-color: rgb(165, 214, 167); color: #333" v-for="i in item.acf.campuses_offered">{{ i }}</span>
                            </div>
                          </div>
                          <div style="padding-top: 5px">
                            <div>{{ item.acf.program_level }}</div>
                            <span uk-icon="icon:chevron-right; ratio: 1.5" ></span>
                          </div>
                        </div>
                      </div>

                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>
          <div class="uk-container uk-container-small" v-if="tableView === true">

            <div class="uk-overflow-auto"  v-if="tableView === true">
              <table class="uk-table  uk-table-divider ">
                <thead>
                <tr>
                  <th > <h3 style="color: rgb(197,179,88) !important;" class="uk-heading-bullet specHeading">List of Undergraduate Degrees</h3></th>
                  <th class="uk-table-shrink">Dept.</th>
                  <th class="uk-table-shrink">A.Sc</th>
                  <th class="uk-table-shrink">A.A</th>
                  <th class="uk-table-shrink">B.Sc</th>
                  <th class="uk-table-shrink">B.A</th>
                </tr>
                </thead>
                <tbody class="">
                <tr v-for="item in filterDegree">
                  <td>
                    <a href="javascript:" :id="item.id" v-on:click="findNewDegree" :uk-tooltip="'Learn more about a degree in ' + item.degreeName" class="uk-button-link  uk-uk-text-bold ">{{ item.degreeName }} </a>
                  </td>

                  <td>

                    <span  class="uk-margin-small-right uk-text-primary uk-text-small" ><i>{{ item.department }}</i></span>
                  </td><td>

                  <span v-if="item.associate_science" class="uk-margin-small-right uk-text-primary" uk-icon="check"></span>
                </td>
                  <td class="uk-text-center">
                    <span v-if="item.associate_arts" class="uk-margin-small-right uk-text-primary" uk-icon="check"></span>
                  </td>
                  <td>

                    <span v-if="item.bachelor_science" class="uk-margin-small-right uk-text-primary" uk-icon="check"></span>
                  </td>
                  <td class="uk-text-center">
                    <span v-if="item.bachelor_arts" class="uk-margin-small-right uk-text-primary" uk-icon="check"></span>
                  </td>

                </tr>


                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div  id="deps" class="uk-background-muted uk-margin-remove-top">
          <div class="uk-container uk-container-small">
            <br>
            <div v-if="imgHide">
              <img src="../assets/loading.gif" style="max-height: 220px; max-width: 220px; width: auto; height: auto;" alt="" class="uk-align-center">
            </div>
            <div v-if="tableView === true">
              <h3 class="uk-heading-bullet specHeading uk-margin-remove-bottom">Departments</h3>
              <div class="uk-child-width-1-2@m uk-padding uk-padding-remove-vertical" uk-grid>
                <div class=" uk-padding-small uk-margin-top uk-border-rounded uk-text-small uk-text-muted" >
                  <p class="">BHM - Department of Business and Hospitality Management </p>
                  <p class="">GEL - Department of Graduate Education and Leadership </p>
                  <p class="">GP - Department of Graduate Psychology </p><p class="">BHM - Department of Business and Hospitality Management </p>
                  <p class="">BSS - Department of Behavioural and Social Sciences </p>
                  <p class="">COMM - Department of Communication Studies </p>
                  <p class="">HUM - Department of Humanities </p>
                  <p class="">ME - Department of Mathematics and Engineering </p>
                  <p class="">MT - Department of Medical Technology </p>


                </div>
                <div class=" uk-padding-small uk-margin-top uk-border-rounded uk-text-small uk-text-muted" >
                  <p class="">MFA - Department of Music and Fine Arts </p>
                  <p class="">N - Department of Nursing </p>
                  <p class="">BCES - Department of Biology, Chemistry and Environmental Sciences </p>
                  <p class="">CIS - Department of Computer and Information Science</p>
                  <p class="">DNFS - Department of Dietetics, Nutrition and Food Science</p>
                  <p class="">DH - Department of Dental Hygiene </p>
                  <p class="">GS - Department of General Studies </p>
                  <p class="">SRT - School of Religion and Theology  </p>
                  <p class="">TED - Department of Teacher Education  </p>

                </div>

              </div>
            </div>
            <!--<br>-->
          </div>

          <div class="uk-container uk-container-small">
           <!-- <br>-->
            <div v-if="imgHide">
              <!--<img src="../assets/loading.gif" style="max-height: 220px; max-width: 220px; width: auto; height: auto;" alt="" class="uk-align-center">-->
            </div>
            <h3 class="uk-heading-bullet specHeading uk-margin-remove-bottom">Degrees</h3>
            <div class="uk-child-width-1-2@m uk-padding uk-padding-remove-vertical" uk-grid>
              <div class=" uk-padding-small uk-margin-top uk-border-rounded uk-text-small uk-text-muted" >
                <p class="">A.Sc - Associate of Science </p>
                <p class="">A.A - Associate of Arts </p>

              </div>
              <div class=" uk-padding-small uk-margin-top uk-border-rounded uk-text-small uk-text-muted" >
                <p class="">B.Sc - Bachelors of Science </p>
                <p class="">B.A - Bachelors of Arts </p>


              </div>

            </div>
            <br>
          </div>

        </div>
      </div>

    </div>
  </transition>
</template>

<script>
    export default {
        name: "undergradprograms",
        data(){
          return {
            image: location.origin + '/static/logo.png',
            imgHide: true,
            tableView: false,
            gridView: true,
            searchDegree: ''
          }
        },
      methods: {
        findDegree: function(event){
          //this.$store.commit('getArticle', (event.target.id))
          //console.log(event.target)
          this.$router.push({ path: '/undergrad', query: { degreeName: event.target.id, degreeType: 'u_programs' }})
        },
        findNewDegree: function(slug){
          //this.$store.commit('getArticle', (event.target.id))
          //console.log(event.target)
          console.log(slug)
          this.$store.state.FeatureStory = {}
          this.$router.push({ path: '/undergrad', query: { degree: slug }})
        },
        switchToGrid: function(){
          this.tableView = false
          this.gridView = true
        },
        switchToTable: function(){
          this.tableView = true
          this.gridView = false
        },
      },
      computed: {
        loadDegrees: function () {
          //this.pageLoad = true
          //console.log(this.$store.state.undergradDegrees.associate_degree)
          return this.$store.state.degree.undergradDegrees
        },
        loadNewDegrees: function () {
          //this.pageLoad = true
          //console.log(this.$store.state.undergradDegrees.associate_degree)
          return this.$store.state.undergradDegrees
        },
        filterDegree: function(){
          const searchTerm = new RegExp(this.searchDegree, 'i');

          return this.loadNewDegrees.filter((degree) =>{
            //console.log(degree.acf.program_name)
            return degree.acf.program_name.match(searchTerm)
          })
        }
      },
      mounted(){
        this.$store.dispatch('getUndergraduateDegrees')
        window.scrollTo(0, 0);
      },
      beforeCreate(){
        //this.$store.dispatch('degree/AllUndergradDegrees')

      },
      updated(){
        this.imgHide = false
      },
      metaInfo: {
        // Children can override the title.
        title: 'NCU Undergraduate Degrees',
        // Result: My Page Title ← My Site
        // If a child changes the title to "My Other Page Title",
        // it will become: My Other Page Title ← My Site
        //titleTemplate: '%s ← My Site',
        // Define meta tags here.
        meta: [
          {'http-equiv': 'Content-Type', content: 'text/html; charset=utf-8'},
          {name: 'viewport', content: 'width=device-width, initial-scale=1'},
          {name: 'description', content: 'Undergraduate Degrees offered by Northern Caribbean University '}
        ]
      }
    }
</script>

<style scoped>
  #academicsHolder{
    min-height: 75vh;
  }
  .colorIt{
    color: #333 !important;
  }
  .borderIt{
    border: #333 solid 1px !important;
  }
  .bgIt{
    background-color: #333 !important;
  }
  .whiteIt{
    color: white !important;
  }
  .smallSize{
    font-size: 10pt !important;
    padding-left: 15px;
  }
  h4, h5{
    color: silver !important;
  }
  tr > td{
    border: 1px solid #EEEEEE;
    padding-top: 10px;
    padding-bottom: 10px;
    padding-left: 15px;
    padding-right: 15px;
  }
</style>
